import React from 'react';
import FeaturedItems from '../../../shared/templates/CategoryTemplate/featured-items';
import BlogsFeaturedPreview from './BlogsFeaturedPreview';

export default function BlogsFeatured(props) {
    return (
        <FeaturedItems 
            {...props}
            FeaturedItemPreview={BlogsFeaturedPreview}
        />
    );
}